import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { withTranslation, Trans } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

 function SimpleSelect(props) {
  const { t } = props;
  const classes = useStyles();
  const [value, setvalue] = React.useState('');

  const handleChange = (event) => {
    setvalue(event.target.value);
    props.onOptionChange(event.target.value)
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
       
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          onChange={handleChange}
        >
          <MenuItem value={''}>{t('Please Select')}</MenuItem>
          {
            props.options && props.options.length > 0 && props.options.map( obj => {
              return  <MenuItem value={obj}>{t(obj)}</MenuItem>
            })
          }
        </Select>
      </FormControl>  
    </div>
  );
}

export default withTranslation()(SimpleSelect);
